import Vue from 'vue'
import Router from 'vue-router'
import authGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/Base/Home'),
      beforeEnter: authGuard,
      children: [
        {
          path: 'dashboard',
          component: () => import('@/views/Dashboard/Dashboard')
        },
        {
          path: 'connectors/:connectorId',
          component: () => import('@/views/Connector/Connectors')
        },
        {
          path: 'connectors/:connectorId/:deviceType',
          component: () => import('@/views/Connector/DeviceTypes')
        },
        {
          path: 'connectors/:connectorId/:deviceType/:deviceId',
          component: () => import('@/views/Connector/Devices')
        }
      ]
    },
    {
      path: '/signin',
      name: 'Signin',
      component: () => import('@/views/Auth/Signin'),
      beforeEnter: authGuard
    },
    {
      path: '/signup',
      name: 'Signup',
      component: () => import('@/views/Auth/Signup'),
      beforeEnter: authGuard
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js